// @ts-nocheck — notification preference DTO vs stored shape.
import { INotificationRepository } from "../../adapters/driven/repositories/notificationRepository";

export const NotificationServiceImplFactory = ({
  notificationRepository,
}: {
  notificationRepository: INotificationRepository;
}): INotificationService => {
  const getNotificationSetting: IGetNotificationSetting = async () => {
    try {
      const response = await notificationRepository.getNotificationSetting();
      return {
        success: !!response.data,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const setNotificationSetting: ISetNotificationSetting = async (payload) => {
    try {
      const response = await notificationRepository.setNotificationSetting({
        email: payload.email,
        push_notification: payload.pushNotification,
        kiosk_mode: payload.kioskMode,
        psn_alert_preference: payload.psnAlertPreference,
        escalated_alert_preference: payload.escalatedAlertPreference,
        facilities_to_send_notification_for_old_id:
          payload.facilitiesToSendNotificationForOldId,
        bed_exit_preference: payload.bedExitPreference,
        sms: payload.sms,
        phone_number: payload.phoneNumber,
        sms_preferences: payload.smsPreferences,
      });

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  return {
    getNotificationSetting,
    setNotificationSetting,
  };
};
